import React, { useCallback, useState } from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import fire from '../assets/imgs/fire.svg'
import wallet from '../assets/imgs/wallet.svg'
import logo_icon from '../assets/imgs/Voxlink_Logo.png'
import logo_title from '../assets/imgs/Voxlink_white.png'
import footer_image from '../assets/imgs/form-footer.png'
import Card from '../components/Card'
import { isAddress } from 'ethers/lib/utils'
import { toast } from '../utils/toast'
import '../styles/Home.css'

const Home = () => {
  const [burnerAddr, setBurnerAddr] = useState('')
  const [mainAddr, setMainAddr] = useState('')
  const [showPopup, setShowPopup] = useState(false)
  const [errors, setErrors] = useState({
    burnerAddr: '',
    mainAddr: '',
  })

  // This function will run after the form in hero section is submitted
  const handleSecureWalletForm = useCallback(
    (e) => {
      e.preventDefault()
      const isBurnerAddrValid = isAddress(burnerAddr)
      const isMainAddrValid = isAddress(mainAddr)

      if (
        isBurnerAddrValid &&
        isMainAddrValid &&
        burnerAddr.toLowerCase() === mainAddr.toLowerCase()
      ) {
        toast.error('Burner and main address cannot be same')
        return
      }

      if (isBurnerAddrValid === false) {
        setErrors((prev) => ({
          ...prev,
          burnerAddr: 'Invalid burner address',
        }))
      }

      if (isMainAddrValid === false) {
        setErrors((prev) => ({
          ...prev,
          mainAddr: 'Invalid main address',
        }))
      }

      if (isBurnerAddrValid && isMainAddrValid) {
        setShowPopup(true)
      }
    },
    [burnerAddr, mainAddr]
  )

  return (
    <main className="home">
      <section className="main-body">
        <Navbar />
        <main className="hero-section">
          <div className="hero-section-left">
            <h1>Don't put your wallet at risk.</h1>
            <p>
              Ghostmint your NFTs through burning wallet, and send it to the
              main wallet seamlessly.
            </p>
            <p>
              Prove ownership and claim airdrops of your NFTs without connecting
              the main wallet containing the asset
            </p>
            <a href="/">Learn more</a>
          </div>
          <div className="hero-section-right">
            <form>
              <h3
                className={'mb-2 text-2xl font-bold leading-tight text-white'}
              >
                Create a new Voxlink
              </h3>
              <div className="input-boxes">
                <div>
                  <label>
                    <img src={fire} alt="fire" />
                    Burner Addr.
                  </label>
                  <input
                    required
                    value={burnerAddr}
                    onChange={(e) => {
                      setErrors((prev) => ({
                        ...prev,
                        burnerAddr: '',
                      }))
                      setBurnerAddr(e.target.value)
                    }}
                    type="text"
                    placeholder="E.g. Oxe1FD2.."
                  />
                  {errors.burnerAddr && (
                    <p className={'mt-2 text-xs italic text-red-500'}>
                      {errors.burnerAddr}
                    </p>
                  )}
                </div>
                <div className={'flex flex-col'}>
                  <label>
                    <img src={wallet} alt="wallet" />
                    Main Addr.
                  </label>
                  <input
                    required
                    value={mainAddr}
                    onChange={(e) => {
                      setErrors((prev) => ({
                        ...prev,
                        mainAddr: '',
                      }))
                      setMainAddr(e.target.value)
                    }}
                    type="text"
                    placeholder="E.g. Oxe1FD2.."
                  />
                  {errors.mainAddr && (
                    <p className={'mt-2 text-xs italic text-red-500'}>
                      {errors.mainAddr}
                    </p>
                  )}
                </div>
              </div>
              <div className="form-submit">
                <button
                  type="submit"
                  className="primary-btn"
                  onClick={handleSecureWalletForm}
                >
                  Secure Wallet
                </button>
              </div>
              <div className="form-footer">
                <a href="/">How it works?</a>
                <p>
                  Secured by
                  <img
                    style={{ height: '0.75rem' }}
                    src={logo_icon}
                    alt="icon"
                  />
                  <img src={logo_title} alt="title" />
                </p>
              </div>
            </form>
            <img className="form-footer-img" src={footer_image} alt="" />
          </div>
        </main>
      </section>

      <Footer />
      {showPopup && (
        <Card
          mainAddr={mainAddr}
          burnerAddr={burnerAddr}
          onClose={() => {
            setShowPopup(false)
          }}
        />
      )}
    </main>
  )
}

export default Home
